import { QRCodeSVG } from 'qrcode.react';
import { BrowserOnly } from '../client/BrowserOnly';

// QR codes must stay black modules on a white plate regardless of the tenant theme: many phone
// scanners cannot read low-contrast or inverted codes. These are the only literal colors allowed here.
const QR_PLATE_CLASS = 'rounded-2xl bg-white p-2 shadow-sm'; // theme-guard-ignore: QR scanner contrast
const QR_BACKGROUND = '#ffffff'; // theme-guard-ignore: QR scanner contrast
const QR_FOREGROUND = '#000000'; // theme-guard-ignore: QR scanner contrast

interface QrCodeProps {
  value: string;
  label: string;
  size?: number;
}

/**
 * Locally rendered QR code (the value may carry a secret, so never use a remote QR service).
 * Always black on a white plate, even in dark mode: many phone scanners can't read inverted codes.
 */
export function QrCode({ value, label, size = 176 }: QrCodeProps) {
  return <BrowserOnly reason="QR code renders from window.location" fallback={<div aria-hidden="true" className={QR_PLATE_CLASS} style={{ width: size + 16, height: size + 16 }} />}>
    <div
      role="img" aria-label={label} className={QR_PLATE_CLASS}>
      <QRCodeSVG
        value={value}
        size={size}
        level="M"
        marginSize={2}
        bgColor={QR_BACKGROUND}
        fgColor={QR_FOREGROUND}
        aria-hidden="true"
        style={{ display: 'block', maxWidth: '100%', height: 'auto' }}
      />
    </div>
  </BrowserOnly>;
}
